"use client";
import React, { createContext, useContext, useCallback, useState } from "react";
import { BASE_URL } from "../config/config";

const DocumentContext = createContext();

export const DocumentProvider = ({ children }) => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const token = localStorage.getItem("token");

  // 🔹 FETCH
  const fetchDocuments = useCallback(async () => {
    if (!token) return;

    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/course-documents`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await res.json();

      if (res.ok && data.status === 200) {
        setDocuments(data.data || []);
      } else {
        setError(data.message || "Failed to fetch documents");
      }
    } catch {
      setError("Network error");
    } finally {
      setLoading(false);
    }
  }, [token]);

    // 🔹 ADD
    const addDocument = async (formData) => {
        try {
            const user = JSON.parse(localStorage.getItem("user") || "{}");
            const adminId = user.id;
            formData.append("create_audit_id", adminId);

            // for (let pair of formData.entries()) {
            // console.log(pair[0], pair[1]);
            // }
            const res = await fetch(`${BASE_URL}/course-documents`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`, // ✅ FormData, no content-type
            },
            body: formData,
            });
            const data = await res.json();
            if (res.ok && data.status === 200) {
                fetchDocuments(); // refresh list
                return true;
            } else {
                alert(data.message || "Add failed");
            }
        } catch (err) {
            console.error("Network error:", err);
            alert("Network error");
        }
    };

    // 🔹 UPDATE
    const updateDocument = async (id, formData) => {
        try {
            const user = JSON.parse(localStorage.getItem("user") || "{}");
            const adminId = user.id;

            formData.append("update_audit_id", adminId);

            // for (let pair of formData.entries()) {
            // console.log(pair[0], pair[1]);
            // }

            const res = await fetch(`${BASE_URL}/course-documents/${id}`, {
            method: "POST", // or "PATCH" if backend supports it
            headers: {
                Authorization: `Bearer ${token}`, // ❌ Do NOT set 'Content-Type' for FormData
            },
            body: formData,
            });

            const data = await res.json();

            if (res.ok && data.status === 200) {
                fetchDocuments();
            } else {
                alert(data.message || "Update failed");
            }
        } catch (err) {
            alert("Network error");
        }
    };


  // 🔹 DELETE
  const deleteDocument = async (id) => {
    if (!window.confirm("Delete this document?")) return;

    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const adminId = user.id;

      const res = await fetch(`${BASE_URL}/course-documents/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ delete_audit_id: adminId }),
      });

      const data = await res.json();

      if (res.ok && data.status === 200) {
        setDocuments((prev) => prev.filter((d) => d.id !== id));
      } else {
        alert(data.message || "Delete failed");
      }
    } catch {
      alert("Delete failed");
    }
  };

  // 🔹 STATUS TOGGLE
  const toggleDocumentStatus = async (id, currentStatus) => {
    const newStatus = currentStatus === "Active" ? "Inactive" : "Active";

    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const adminId = user.id;

      const res = await fetch(`${BASE_URL}/course-documents/${id}/status`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          status: newStatus,
          update_audit_id: adminId,
        }),
      });

      const data = await res.json();

      if (res.ok && data.status === 200) {
        setDocuments((prev) =>
          prev.map((d) => (d.id === id ? { ...d, status: newStatus } : d))
        );
      } else {
        alert(data.message || "Status update failed");
      }
    } catch {
      alert("Status update failed");
    }
  };

  return (
    <DocumentContext.Provider
      value={{
        documents,
        loading,
        error,
        fetchDocuments,
        addDocument,
        updateDocument,
        deleteDocument,
        toggleDocumentStatus,
      }}
    >
      {children}
    </DocumentContext.Provider>
  );
};

export const useDocuments = () => useContext(DocumentContext);
